import * as React from "react";
import "./ButtonHide.styl";
import Context from "./Context";

export default class ButtonHide extends React.Component<{
    total: number;
}> {

    public render(): React.ReactNode {
        return (
            <Context.Consumer>
                {({dispatch, translate}) => (
                    <div className="Discussion-ButtonHide-Root" onClick={() => {
                        dispatch("display", {display: false, autofocus: true});
                    }}>
                        <div className="Discussion-ButtonHide-Label">
                            {translate(this.getLabelKey(), {
                                count: this.props.total.toString(),
                            })}
                        </div>
                    </div>
                )}
            </Context.Consumer>
        );
    }

    private getLabelKey(): string {
        switch (this.props.total) {
            case 0:
                return "BUTTON_HIDE_0";
            case 1:
                return "BUTTON_HIDE_1";
            case 2:
            case 3:
            case 4:
                return "BUTTON_HIDE_2";
            default:
                return "BUTTON_HIDE_3";
        }
    }

}